// import { useState, useEffect } from "react";
// import api from "../../../core/axios/axiosInstance";
// import EmojiPicker from "emoji-picker-react";

// const AdminPushNotifications = () => {
//   const [heading, setHeading] = useState("");
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [history, setHistory] = useState([]);

//   const fetchNotifications = async () => {
//     try {
//       const res = await api.get("/admin/notification/get");
//       setHistory(
//         Array.isArray(res.data)
//           ? res.data
//           : res.data?.notifications || res.data?.data || []
//       );
//     } catch (error) {
//       console.error("❌ Failed to fetch notifications:", error);
//     }
//   };

//   useEffect(() => {
//     fetchNotifications();
//   }, []);

//   const handleSend = async () => {
//     if (!heading || !message) {
//       alert("Please fill out both heading and message");
//       return;
//     }

//     setLoading(true);
//     try {
//       const payload = {
//         heading,
//         message,
//       };

//       const response = await api.post("/admin/notification", payload);
//       console.log(response.data, "response from send push notification");

//       alert("✅ Notification sent to all users successfully!");
//       setHeading("");
//       setMessage("");

//       await fetchNotifications();
//     } catch (error) {
//       console.error("❌ Send failed:", error);
//       alert("Failed to send notification");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         <div className="card">
//           <div className="card-body">
//             <h5 className="card-title">Create Notification</h5>

//             <div className="mb-3">
//               <label className="form-label">Heading</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 value={heading}
//                 onChange={(e) => setHeading(e.target.value)}
//                 placeholder="Enter notification heading"
//               />
//             </div>

//             <div className="mb-3">
//               <label className="form-label">Message</label>
//               <textarea
//                 className="form-control"
//                 rows="3"
//                 value={message}
//                 onChange={(e) => setMessage(e.target.value)}
//                 placeholder="Enter notification message"
//               />
//             </div>

//             <button
//               className="btn btn-success"
//               onClick={handleSend}
//               disabled={loading}
//             >
//               {loading ? "Sending..." : "Send to All Users"}
//             </button>
//           </div>
//         </div>


//         <div className="card mt-4">
//           <div className="card-body">
//             <h5 className="card-title">Notification History</h5>
//             <table className="table">
//               <thead>
//                 <tr>
//                   <th>Heading</th>
//                   <th>Message</th>
//                   <th>Number of Recipients</th>
//                   <th>Sent On</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {Array.isArray(history) && history.length > 0 ? (
//                   history.map((item) => (
//                     <tr key={item.id}>
//                       <td
//                         style={{
//                           maxWidth: "200px",
//                           maxHeight: "50px",
//                           overflowY: "auto",
//                           overflowX: "auto",
//                           wordBreak: "break-word",
//                         }}
//                       >
//                         {item.heading}
//                       </td>

//                       <td
//                         style={{
//                           maxWidth: "300px",
//                           maxHeight: "80px",
//                           overflowY: "auto",
//                           overflowX: "auto",
//                           wordBreak: "break-word",
//                         }}
//                       >
//                         {item.message}
//                       </td>

//                       <td>
//                         {Array.isArray(item.sentToUsers) ? item.sentToUsers.length : 0}
//                       </td>
//                       <td>
//                         {item.createdAt ? new Date(item.createdAt).toLocaleString() : "-"}
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="4" className="text-center text-muted">
//                       No notifications yet
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminPushNotifications;
import { useState, useEffect, useRef } from "react";
import api from "../../../core/axios/axiosInstance";
import EmojiPicker from "emoji-picker-react";

const AdminPushNotifications = () => {
  const [heading, setHeading] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  const [openPicker, setOpenPicker] = useState(null); // "heading" | "message" | null

  const headingRef = useRef(null);
  const messageRef = useRef(null);
  const pickerRef = useRef(null);

  // ✅ Close picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        !headingRef.current.contains(event.target) &&
        !messageRef.current.contains(event.target)
      ) {
        setOpenPicker(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ Fetch notifications
  const fetchNotifications = async () => {
    try {
      const res = await api.get("/admin/notification/get");
      setHistory(
        Array.isArray(res.data)
          ? res.data
          : res.data?.notifications || res.data?.data || []
      );
    } catch (error) {
      console.error("❌ Failed to fetch notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // ✅ Emoji insertion logic
  const handleEmojiClick = (emojiData, field) => {
    const emoji = emojiData.emoji;
    if (field === "heading") {
      const input = headingRef.current;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const newText = heading.slice(0, start) + emoji + heading.slice(end);
      setHeading(newText);
      setTimeout(() => {
        input.selectionStart = input.selectionEnd = start + emoji.length;
        input.focus();
      }, 0);
    } else {
      const input = messageRef.current;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      const newText = message.slice(0, start) + emoji + message.slice(end);
      setMessage(newText);
      setTimeout(() => {
        input.selectionStart = input.selectionEnd = start + emoji.length;
        input.focus();
      }, 0);
    }
  };

  // ✅ Send notification
  const handleSend = async () => {
    if (!heading || !message) {
      alert("Please fill out both heading and message");
      return;
    }

    setLoading(true);
    try {
      const payload = { heading, message };
      await api.post("/admin/notification", payload);
      alert("✅ Notification sent to all users successfully!");
      setHeading("");
      setMessage("");
      await fetchNotifications();
    } catch (error) {
      console.error("❌ Send failed:", error);
      alert("Failed to send notification");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Create Notification</h5>

            {/* HEADING FIELD */}
            <div className="mb-3 position-relative">
              <label className="form-label">Heading</label>
              <div className="d-flex align-items-center">
                <input
                  ref={headingRef}
                  type="text"
                  className="form-control"
                  value={heading}
                  onChange={(e) => setHeading(e.target.value)}
                  placeholder="Enter notification heading"
                  onClick={() => setOpenPicker(null)}
                />
                <button
                  type="button"
                  className="btn btn-light ms-2"
                  onClick={() =>
                    setOpenPicker(openPicker === "heading" ? null : "heading")
                  }
                >
                  😀
                </button>
              </div>

              {openPicker === "heading" && (
                <div
                  ref={pickerRef}
                  style={{
                    position: "absolute",
                    zIndex: 1000,
                     top: "100%",
            right: 0,
                    marginTop: "10px",
                  }}
                >
                  <EmojiPicker
                    onEmojiClick={(emojiData) =>
                      handleEmojiClick(emojiData, "heading")
                    }
                  />
                </div>
              )}
            </div>

            {/* MESSAGE FIELD */}
            <div className="mb-3 position-relative">
              <label className="form-label">Message</label>
              <div className="d-flex align-items-start">
                <textarea
                  ref={messageRef}
                  className="form-control"
                  rows="3"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Enter notification message"
                  onClick={() => setOpenPicker(null)}
                />
                <button
                  type="button"
                  className="btn btn-light ms-2 mt-1"
                  onClick={() =>
                    setOpenPicker(openPicker === "message" ? null : "message")
                  }
                >
                  😎
                </button>
              </div>


              {openPicker === "message" && (
                <div
                  ref={pickerRef}
                  style={{
                    position: "absolute",
                    zIndex: 1000,
                     top: "100%",
            right: 0,
                    marginTop: "10px",
                  }}
                >
                  <EmojiPicker
                    onEmojiClick={(emojiData) =>
                      handleEmojiClick(emojiData, "message")
                    }
                  />
                </div>
              )}
            </div>

            <button
              className="btn btn-success"
              onClick={handleSend}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send to All Users"}
            </button>
          </div>
        </div>

        {/* HISTORY TABLE */}
        <div className="card mt-4">
          <div className="card-body">
            <h5 className="card-title">Notification History</h5>
            <table className="table">
              <thead>
                <tr>
                  <th>Heading</th>
                  <th>Message</th>
                  <th>Number of Recipients</th>
                  <th>Sent On</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(history) && history.length > 0 ? (
                  history.map((item) => (
                    <tr key={item.id}>
                      <td
                        style={{
                          maxWidth: "200px",
                          overflowY: "auto",
                          wordBreak: "break-word",
                        }}
                      >
                        {item.heading}
                      </td>
                      <td
                        style={{
                          maxWidth: "300px",
                          overflowY: "auto",
                          wordBreak: "break-word",
                        }}
                      >
                        {item.message}
                      </td>
                      <td>
                        {Array.isArray(item.sentToUsers)
                          ? item.sentToUsers.length
                          : 0}
                      </td>
                      <td>
                        {item.createdAt
                          ? new Date(item.createdAt).toLocaleString()
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center text-muted">
                      No notifications yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPushNotifications;
